import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail", "arrow"]

  toggle() {
    const isHidden = this.detailTarget.classList.contains("hidden")
    this.detailTarget.classList.toggle("hidden")
    this.arrowTarget.style.transform = isHidden ? "rotate(180deg)" : ""
  }
}
